<template>
    <!-- container -->
    <div id="container">
        <div class="container_wrap">
            <!-- snb -->
            <faq-snb></faq-snb>
            <!-- //snb -->
            <!-- contents -->
            <fragment>
                <router-view></router-view>
            </fragment>
            <!-- //contents -->
        </div>
    </div>
    <!-- //container -->
</template>

<script>
import faqSnb from '~vb/faq/common/faqSnb';

export default {
    name: 'faqMain',
    components: {
        'faq-snb': faqSnb,
    },
    data() {
        return {};
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/common/faqMain.vue